/* eslint-disable import/no-extraneous-dependencies */
import 'whatwg-fetch'; // Polyfill
import createGallery from './creative-challenge/gallery';
import config from './config';

const BASE_PATH = config.staticFile('features/2021-poster-challenge');
const DATA_FILE = `${BASE_PATH}/2021-poster-challenge.json`;
const IMAGES_PATH = `${BASE_PATH}/files`;
const THUMBS_PATH = `${BASE_PATH}/files-thumb`;
const ROUTE_PREFIX = 'poster-';

export function fetchPosters(dataFile, imagesPath, thumbsPath) {
  return window.fetch(dataFile, {
    cache: 'no-cache',
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Could not read ${dataFile}.`);
      }
      return response;
    })
    .then((response) => response.json())
    .then((data) => data.posters)
    .then((posters) => posters.map(
      (poster) => (
        {
          ...poster,
          file: `${imagesPath}/${poster.id}.${poster.fileType}`,
          image: `${thumbsPath}/medium/${poster.id}.jpg`,
          thumbnail: `${thumbsPath}/small/${poster.id}.jpg`,
          route: `#${ROUTE_PREFIX}${poster.id}`,
        })
    ));
}

export function renderDetailView(poster) {
  const content = [];
  const notEmpty = (s) => s && (typeof s === 'string') && (s.trim().length > 0);
  if (notEmpty(poster.submitterName)) {
    content.push($('<div class="submitterName"></div>').html(`Submitted by <strong>${poster.submitterName}</strong>`));
  }
  if (notEmpty(poster.location)) {
    content.push($('<div class="location"></div>').html(poster.location));
  }
  if (notEmpty(poster.description)) {
    content.push($('<div class="description"></div>').html(poster.description));
  }
  if (notEmpty(poster.credits)) {
    content.push($('<h2 class="small mb-1"></h2>').html('Credits'));
    content.push($('<div class="credits"></div>').html(poster.credits));
  }
  content.push($('<a class="download mt-3"></a>')
    .attr('href', poster.file)
    .text('Download in full resolution'));

  return $('<div class="row poster-challenge-details">')
    .append($('<div class="col-lg col-md-12"></div>')
      .append($('<a class="dl-link-img mb-4"></a>')
        .attr('href', poster.file)
        .append($('<img class="img-fluid">')
          .attr('src', poster.image)
          .attr('alt', ''))))
    .append($('<div class="col-lg col-md-12"></div>')
      .append(content));
}

$('[data-component=2021-poster-challenge]').each((i, element) => {
  fetchPosters(DATA_FILE, IMAGES_PATH, THUMBS_PATH).then((posters) => {
    createGallery(element, posters, renderDetailView);
  });
});

$('[data-component=2021-celebration-poster]').each((i, element) => {
  const CELEBRATION_BASE_PATH = config.staticFile('features/2021-posters-celebration');
  fetchPosters(
    `${CELEBRATION_BASE_PATH}/2021-poster-celebration.json`,
    `${CELEBRATION_BASE_PATH}/files`,
    `${CELEBRATION_BASE_PATH}/files-thumb`
  ).then((posters) => {
    createGallery(element, posters, renderDetailView);
  });
});
